import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOffline = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2.02808 2.05603L15.9721 16",
			stroke: "#D9DEEB",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.5 7.5C4.5 7.5 4.37883 7.84621 4.34725 8.386C3.98324 8.30978 3.60681 8.31568 3.24537 8.40329C2.88393 8.4909 2.54657 8.658 2.25786 8.89243C1.96915 9.12686 1.73634 9.42272 1.5764 9.75848C1.41645 10.0942 1.33339 10.4614 1.33325 10.8333C1.33325 13.3733 3.99992 13.3333 3.99992 13.3333H10",
			stroke: "#D9DEEB",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.5 12.5C16 12 16.1875 11.7766 16.1875 11.7766C16.5219 11.246 16.6889 10.6269 16.6667 10C16.6671 9.55221 16.5771 9.10895 16.4021 8.69678C16.2271 8.28461 15.9707 7.91201 15.6482 7.60131C15.3257 7.29062 14.9439 7.04822 14.5255 6.88865C14.1071 6.72908 13.6608 6.65562 13.2133 6.67267C12.9373 6.08718 12.5423 5.56561 12.0535 5.14122C11.5648 4.71683 10.993 4.39892 10.3746 4.20775C9.75613 4.01658 9.10467 3.95634 8.46168 4.03088C7.81869 4.10541 8.46168 4.03088 7.35376 4.20775",
			stroke: "#D9DEEB",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgOffline);
export default ForwardRef;
